import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractInvoiceApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contractInvoice'
  }

  /**
   * 导出
   * @returns
   */
  public excel(params) {
    return this.download(params, "excel")
  }


}